import React from 'react'
import Hero from './components/hero';



function Blogs() {
    return (
      <div>
        <Hero />
      </div>
    )
  }

  export default Blogs;